import React from 'react';
import { Component } from '../../../dispatcher/modules';
import Container from '../container/Container';
import _ from 'lodash';
import classNames from 'classnames';
import { PUZZLE_PANEL_ROW_PROPS } from './Types';

export default class PuzzlePanelRow extends Component<PUZZLE_PANEL_ROW_PROPS> {
  static defaultProps = {
    hBox: true,
    alignItemsCenter: true
  }

  render() {
    const {
      children,
      className = ''
    } = this.props;

    const panelRowClasses = classNames(
      `tp-panel-row ${className}`
    );

    const puzzlePanelRowProps = _.omit(this.props, ['children', 'className']);

    return (
      <Container
        {...puzzlePanelRowProps}
        className={panelRowClasses}
      >
        {children}
      </Container>
    );
  }
}
